import { twMerge } from 'tailwind-merge'
import { weekGridClasses } from '@utils/styles'

interface TableProps {
  children?: React.ReactNode
  className?: string
  weekStartsOn: 'sunday' | 'monday'
}

export function Table(props: TableProps) {
  return (
    <div
      className={twMerge(
        `auto-rows-fr ${weekGridClasses(props.weekStartsOn)}`,
        props.className,
      )}
    >
      {props.children}
    </div>
  )
}
